import Zone from "@insite/client-framework/Components/Zone";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { getPageLinkByPageType } from "@insite/client-framework/Store/Links/LinksSelectors";
import PageModule from "@insite/client-framework/Types/PageModule";
import PageProps from "@insite/client-framework/Types/PageProps";
import Page from "@insite/mobius/Page";
import { HasHistory, withHistory } from "@insite/mobius/utilities/HistoryContext";
import * as React from "react";
import { useEffect } from "react";
import { connect } from "react-redux";

const mapStateToProps = (state: ApplicationState) => ({
    isAuthenticated: state.context.session.isAuthenticated,
    signInUrl: getPageLinkByPageType(state, "SignInPage")?.url,
});

type Props = PageProps & ReturnType<typeof mapStateToProps> & HasHistory;

const ExemptionCertificatePage: React.FC<Props> = ({ id, isAuthenticated, signInUrl, history }) => {
    useEffect(() => {
        if (!isAuthenticated && signInUrl) {
            const returnUrl = encodeURIComponent(window.location.pathname + window.location.search);
            history.push(`${signInUrl}?returnUrl=${returnUrl}&clientRedirect=true`);
        }
    }, [isAuthenticated, signInUrl]);

    if (!isAuthenticated) {
        return null;
    }

    return (
        <Page>
            <Zone contentId={id} zoneName="Content" />
        </Page>
    );
};

const pageModule: PageModule = {
    component: connect(mapStateToProps)(withHistory(ExemptionCertificatePage)),
    definition: {
        hasEditableUrlSegment: true,
        hasEditableTitle: true,
        pageType: "System",
    },
};

export default pageModule;

export const ExemptionCertificatePageContext = "ExemptionCertificatePage";
